exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}



//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/history/~/deep-equal/lib/keys.js
// module id = 230
// module chunks = 1 4 6